import React from 'react';
import { AutocompleteInput, useRecordContext } from 'react-admin';

const choices = [
	{ id: 'pending', name: 'Pending' },
	{ id: 'accepted', name: 'Accepted' },
	{ id: 'refused', name: 'Refused' }
];

const StatusInput = ({ classes, source = 'status', ...props }) => {
	const record = useRecordContext();

	return (
		<AutocompleteInput choices={choices} source={source} record={record} {...props} />
	);
};

export default StatusInput;
